import React, { useMemo } from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { getWidgetConfig } from "../registry/widgetRegistry";
import WidgetWrapper from "./WidgetWrapper";
import { Empty } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";

const ReactGridLayout = WidthProvider(RGL);

const DashboardGrid = ({ layout, onLayoutChange, onRemoveItem, onWidgetRequestResize, isDraggable = false, isResizable = false }) => {
    // 渲染单个 Grid Item
    const generateDOM = () => {
        return layout.map((item) => {
            const widgetConfig = getWidgetConfig(item.i);

            if (!widgetConfig) {
                // 如果找不到组件配置（可能是前端代码删除了，但数据库还有记录），显示错误或跳过
                return (
                    <div key={item.i} className="widget-error">
                        {isDraggable && (
                            <CloseCircleFilled
                                style={{
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                    zIndex: 100,
                                    fontSize: 20,
                                    color: "#ff4d4f",
                                    cursor: "pointer",
                                    background: "#fff",
                                    borderRadius: "50%",
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onRemoveItem && onRemoveItem(item.i);
                                }}
                            />
                        )}
                        <WidgetWrapper title="Unknown Widget">
                            <Empty description={`Widget ${item.i} not found`} />
                        </WidgetWrapper>
                    </div>
                );
            }

            const WidgetComponent = widgetConfig.component;

            return (
                <div key={item.i} data-grid={item} className={isDraggable ? "widget-editing" : ""}>
                    {isDraggable && (
                        <CloseCircleFilled
                            style={{
                                position: "absolute",
                                top: -8,
                                right: -8,
                                zIndex: 100,
                                fontSize: 20,
                                color: "#ff4d4f",
                                cursor: "pointer",
                                background: "#fff",
                                borderRadius: "50%",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                            }}
                            onClick={(e) => {
                                e.stopPropagation(); // 防止触发拖拽
                                onRemoveItem && onRemoveItem(item.i);
                            }}
                            title="隐藏此组件"
                        />
                    )}
                    <div className="widget-container" style={{ height: "100%" }}>
                        <WidgetComponent
                            isEditing={isDraggable}
                            onRequestResize={onWidgetRequestResize ? (h) => onWidgetRequestResize(item.i, h) : undefined}
                        />
                    </div>
                </div>
            );
        });
    };

    if (!layout || layout.length === 0) {
        return <Empty description="暂无仪表盘配置" style={{ marginTop: 100 }} />;
    }

    return (
        <ReactGridLayout
            className="layout dashboard-grid"
            layout={layout}
            cols={12} // 12列栅格
            rowHeight={100} // 行高 100px
            width={1200} // 默认宽度，WidthProvider 会自动覆盖
            onLayoutChange={onLayoutChange}
            isDraggable={isDraggable}
            isResizable={isResizable}
            draggableHandle=".ant-card-head, .widget-drag-handle" // Support both standard card header and custom handle
            margin={[16, 16]}
        >
            {generateDOM()}
        </ReactGridLayout>
    );
};

export default DashboardGrid;
